import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import useApiData from "../../../hooks/useApiData";

interface Pdc {
  id: number;
  name: string;
}

interface PdcFilterProps {
  value: number | undefined;
  onChange: (pdcId: number | undefined) => void;
}

export default function PdcFilter({ value, onChange }: PdcFilterProps) {
  const { apiData } = useApiData();
  const powerDistributionCompanies = apiData?.powerDistributionCompanies || [];

  // Encontrar PDC selecionada
  const selectedPdc =
    powerDistributionCompanies.find((pdc: Pdc) => pdc.id === value) || null;

  const handleChange = (_event: any, newValue: Pdc | null) => {
    onChange(newValue ? newValue.id : undefined);
  };

  return (
    <Autocomplete
      options={powerDistributionCompanies}
      value={selectedPdc}
      onChange={handleChange}
      getOptionLabel={(option: Pdc) => option.name}
      isOptionEqualToValue={(option: Pdc, value: Pdc) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Concessionária"
          placeholder="Selecione uma concessionária"
        />
      )}
    />
  );
}

